import { type Common } from './common.js';
import { type AgentConversationTagQuery, type Tag } from './models/agentConversationTags.js';

export class API {
  common: Common;
  baseEndpoint: string;

  constructor(common: Common) {
    this.common = common;
    this.baseEndpoint = '/agent-conversations/tags';
  }

  async getTags(query: AgentConversationTagQuery): Promise<{ agentConversationTags: Tag[] }> {
    const url = this.common.constructPath(this.baseEndpoint, query);
    return await this.common.getJSON(url);
  }
}
